import { Checkout, SpecialPaymentResponse } from 'core/domains/checkout';

export const specialPaymentsPresenter = ({
  data,
}: SpecialPaymentResponse): Checkout['specialPayments'] => {
  return data.specialPayments;
};
